import React from 'react';

import { Container } from './styles/withdraws';

const Withdraws = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Withdraws;
